import AbstractFormulaVisitor from "./AbstractFormulaVisitor.js";
import SumFormulaNode from "../SumFormulaNode.js";

/**
 * Convert an addition of an addition into a sum. E.g., "(1 + (2 +
 * 3))" should be converted to "sum(1, 2, 3)".
 */
export default class AdditionToSumOptimizingVisitor extends AbstractFormulaVisitor {
	optimize(node) {
		return this.visit(node);
	}

	visitAbstractNode(node) {
		return node;
	}

	visitAdditionNode(additionNode) {
		const isLeftOperandAddition = additionNode
			.getLeftOperand()
			.isAdditionFormulaNode();

		const isRightOperandAddition = additionNode
			.getRightOperand()
			.isAdditionFormulaNode();

		if (!isLeftOperandAddition && !isRightOperandAddition) {
			return super.visitAdditionNode(additionNode);
		}

		return new SumFormulaNode({
			operands: [
				...this._inlineAdditionNodeOperands(
					additionNode.getLeftOperand(),
				),
				...this._inlineAdditionNodeOperands(
					additionNode.getRightOperand(),
				),
			],
		});
	}

	visitBinaryOperatorNode(binaryNode) {
		const leftOperand = this.visit(binaryNode.getLeftOperand());
		const rightOperand = this.visit(binaryNode.getRightOperand());

		if (
			leftOperand === binaryNode.getLeftOperand() &&
			rightOperand === binaryNode.getRightOperand()
		) {
			return binaryNode;
		}

		return new binaryNode.constructor({ leftOperand, rightOperand });
	}

	visitWrapperNode(wrapperNode) {
		const expression = this.visit(wrapperNode.getExpression());

		if (expression === wrapperNode.getExpression()) {
			return wrapperNode;
		}

		return new wrapperNode.constructor({ expression });
	}

	_inlineAdditionNodeOperands(node) {
		return node.isAdditionFormulaNode()
			? [node.getLeftOperand(), node.getRightOperand()]
			: [node];
	}
}
